import { Permissions } from 'reducers/root.reducer';

import {
  propertyManagerRolePermission,
  propertyOwnerRolePermission,
} from '../RMS/utils/permissions';

export const salesChannelRolePermissions: Permissions = [
  'Owner',
  'ManagedOwner',
  'FlipdishStaff',
  ...propertyManagerRolePermission,
  ...propertyOwnerRolePermission,
];

export const salesChannelAuthZPermissions: Permissions = ['ViewSalesChannels', 'FlipdishStaff'];

export const getSalesChannelPermissions = (useAuthZPermissions: boolean): Permissions =>
  useAuthZPermissions ? salesChannelAuthZPermissions : salesChannelRolePermissions;

export const salesChannelPermissions = salesChannelRolePermissions;
